import React from "react";
import "../../css/PawPrint.css"; // Assuming the CSS is in a separate file.
import { ThemeContext } from "../../contexts/ThemeContext";

const PawPrint = () => {
  const { mode } = React.useContext(ThemeContext);
  const theme = mode == "dark" ? "shaper" : "shaper light";
  const themeClass = mode === "light" ? "light-mode" : "";
  const toes = [1, 2, 3, 4];
  return (
    <div id="paw-wrapper" className={themeClass}>
      <div className="paw-print">
        {toes.map((toe, index) => (
          <div className={`toe toe-${toe}`} key={index}></div>
        ))}
        <div className="box">
          <div className={`${theme} left`}></div>
          <div className={`${theme} right`}></div>
          <div className={`shaper left second`}></div>
          <div className={`shaper right second`}></div>
          <div className={`shaper right third`}></div>
          <div className="base"></div>
        </div>
      </div>
    </div>
  );
};

export default PawPrint;
